export default {
  /**
   *
   * @param {*String} word 🍋
   * @param {*Number} len 🍂
   * @return {*Boolean} if the word more than it should be 😄
   *
   */
  isMoreThanLen: (str, len = 10) => str.length >= len,
  substring: (str, len) =>
    str.length > len ? `${str.substring(0, len)}...` : str,
};
